import { render, staticRenderFns } from "./CreateOffRoad.vue?vue&type=template&id=336dfb9a&scoped=true"
import script from "./CreateOffRoad.vue?vue&type=script&lang=js"
export * from "./CreateOffRoad.vue?vue&type=script&lang=js"
import style0 from "./CreateOffRoad.vue?vue&type=style&index=0&id=336dfb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336dfb9a",
  null
  
)

export default component.exports